import { accountsApi } from "@api";
import { useSession } from "@hooks/useSession";
import { sessionService } from "@services/sessionService";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useWSMutation } from "../../query/helpers";
import { prefetchData } from "./prefetchData";

export const useInitMemberApp = () => {
  const history = useHistory();
  const location = useLocation();
  const session = useSession();

  useEffect(() => {
    const skipPhoneVerification = new URLSearchParams(location.search).get(
      "skipPhoneVerification"
    );

    if (skipPhoneVerification) {
      sessionStorage.setItem("skipPhoneVerification", "true");
    }
  }, [location.search]);

  return useWSMutation(
    async () => {
      // ----------------------------------------------------------------
      // Init data
      // ----------------------------------------------------------------

      // 1. Pull all accounts person has access to
      let accounts = (await accountsApi.listAccounts()).data || [];

      // 2. If no accounts, create a new one and re-list to get it
      if (accounts.length === 0) {
        await accountsApi.createAccount({
          accountCreate: {}
        });
        accounts = (await accountsApi.listAccounts()).data || [];
      }

      // 3. Bind account to session
      if (!session.accountId) {
        await sessionService.switchAccount(accounts[0].id);
      }

      // After signing in redirect user to the stored in the hash location
      if (location.pathname === "/member/sign-in" && location.hash) {
        history.replace(location.hash.slice(1));
        return;
      }

      // // 4. Load incoming payer->payee link requests (Pending + Linked) so both a
      // //    fresh invite and an already-linked returning payee are detected.
      // //    Only incoming requests (this account is the target) are accept-able;
      // //    acceptLinkRequest links to the account bound to the session above.
      // const incomingLinkRequests =
      //   (
      //     await linkRequestsApi.listIncomingPayerPayeeLinkRequests({
      //       filter: {
      //         status: {
      //           anyOf: [LinkRequestStatus.PENDING, LinkRequestStatus.LINKED]
      //         }
      //       }
      //     })
      //   ).data ?? [];
      // const pendingLinkRequest = incomingLinkRequests.find(
      //   linkRequest => linkRequest.status === LinkRequestStatus.PENDING
      // );
      // // Resolve the link request that tells us this person's role: the one just
      // // accepted, or an already-linked one (the list omits `subject`, so fetch).
      // let payeeLinkRequest = pendingLinkRequest
      //   ? await linkRequestsApi.acceptLinkRequest({
      //       linkRequestId: pendingLinkRequest.id,
      //       linkRequestAccept: { acceptingAccountId: accounts[0].id }
      //     })
      //   : undefined;
      // if (!payeeLinkRequest) {
      //   const linkedLinkRequest = incomingLinkRequests.find(
      //     linkRequest => linkRequest.status === LinkRequestStatus.LINKED
      //   );
      //   if (linkedLinkRequest) {
      //     payeeLinkRequest = await linkRequestsApi.getLinkRequest({
      //       linkRequestId: linkedLinkRequest.id
      //     });
      //   }
      // }

      // // 5. A payee linked to a payer who has not completed onboarding is routed
      // //    back to it on every init — fresh accept, refresh, or re-login alike
      // //    (unless they are already inside the onboarding flow).
      // //    getOnboardingStatus throws for a payee with no entity yet — that is
      // //    the unverified case, so route them to onboarding either way.
      // if (
      //   payeeLinkRequest?.subject.type === SubjectType.PAYEE &&
      //   !location.pathname.startsWith("/member/onboarding")
      // ) {
      //   let isTaxVerified = false;
      //   try {
      //     const onboardingStatus = await onboardingApi.getOnboardingStatus({});
      //     isTaxVerified =
      //       onboardingStatus.verifications?.tax === VerificationLevel.VERIFIED;
      //   } catch {
      //     isTaxVerified = false;
      //   }
      //   if (!isTaxVerified) {
      //     history.replace("/member/onboarding/payee");
      //     return;
      //   }
      // }

      // v1 tax-documents redirect disabled during v3 migration:
      // if (
      //   location.pathname === "/member/sign-in" &&
      //   (await getShouldRedirectToTaxDocuments())
      // ) {
      //   history.replace("/member/tax-documents");
      //   return;
      // }

      // v1 invoices redirect disabled during v3 migration:
      // After signing in redirect user to the invoices page if user has at least one invoice
      // if (
      //   location.pathname === "/member/sign-in" &&
      //   (await getHasAtLeastOneInvoice())
      // ) {
      //   history.replace("/member/invoices");
      //   return;
      // }

      // After regular sign in redirect user to the dashboard page
      if (location.pathname === "/member/sign-in") {
        history.replace("/member/dashboard");
        return;
      }
    },
    {
      onSuccess: prefetchData
    }
  );
};

// v1 init helpers disabled during v3 migration. initUser, initMember and
// initClient were removed; the remaining v1 helpers below are kept commented
// out until they are migrated to v3.

// const getShouldRedirectToTaxDocuments = async () => {
//   if (!isAfterJan22AndBeforeFeb9()) {
//     return false;
//   }
//
//   try {
//     const taxForms = await paymentsService.taxForm.payeeList(
//       // expecting that featureFlags already fetched
//       getDefaultTaxYear()
//     );
//     const confirmedTaxDocuments = taxForms.filter(
//       taxForm => taxForm.recipientConfirmedW9Info
//     );
//     return confirmedTaxDocuments.length > 0;
//   } catch {
//     return false;
//   }
// };
//
// const isAfterJan22AndBeforeFeb9 = () => {
//   const today = new Date();
//   const jan22 = new Date(today.getFullYear(), 0, 22);
//   const feb9 = new Date(today.getFullYear(), 1, 9, 23, 59, 59);
//
//   return jan22 < today && today < feb9;
// };
//
// const initOrganizationAccountsExistence = async (
//   userId: string,
//   setStore: ReturnType<typeof useSetWSStore>
// ) => {
//   try {
//     const listSize = await usersService.organization.users.listSize();
//     const xWingspanExpansion = listSize ? userId : undefined;
//
//     setStore({ xWingspanExpansion });
//
//     WSQueryCache.setQueryData(
//       [QUERY_USERS_ALL_ORGANIZATION_USERS_LIST_SIZE, undefined],
//       listSize
//     );
//
//     return listSize;
//   } catch (error) {
//     return [];
//   }
// };
//
// const getHasAtLeastOneInvoice = async () => {
//   try {
//     const invoices = await paymentsService.invoice.list();
//     return invoices.length > 0;
//   } catch {
//     return false;
//   }
// };
